import { lazy } from "react";

const EventPage = lazy(() => import("./main"));
const CreateEventpage = lazy(() => import("./create"));
const UpdateEventpage = lazy(() => import("./update"));

export { EventPage, CreateEventpage, UpdateEventpage };
